<template>
  <div>
    <app-header color="primary"></app-header>
    <main class="register">
      <div class="container-fluid">
<!--        <div class="upload-image-wrapper"  @click="showUpload" >-->
<!--          <div class="upload-image">-->
<!--            <img v-if="registerForm.profile_picture == null" class="camera" src="../assets/img/profile/camera.png" alt="upload">-->
<!--            <img v-else class="camera" :src="registerForm.profile_picture" alt="upload" style="border-radius: 50%; width: 100%; height: 100%">-->
<!--          </div>-->
<!--        </div>-->

        <b-form class="register-form" @submit="onSubmitResetForm">
          <label class="email-label">กรอก email เพื่อส่งคำขอเปลี่ยนรหัสผ่าน :</label>
          <b-form-input
                  v-model="registerForm.email"
                  class="form-control-custom"
                  required
                  placeholder="อีเมล">
          </b-form-input>

        </b-form>
      </div>

      <hr>

      <div class="container-fluid">
        <div class="text-center">
          <button
                  type="button"
                  class="btn btn-custom-primary btn-round shadow-bottom"
                  @click="onSubmitResetForm">
            ยืนยัน
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import AppHeader from '../components/Header.component'
  import Services from '../services'

  export default {
    name: 'reset',
    components: {
      AppHeader
    },
    data () {
      return {
        registerForm: {
          email: ''
        }
      }
    },
    methods: {
      onSubmitResetForm () {
        // eslint-disable-next-line no-undef
        NProgress.start()
        var self = this
        Services.auth.resetPassword(this.registerForm.email).then(function (response) {
          // eslint-disable-next-line no-undef
          NProgress.done()
          var status = response.status
          if (status === 'success') {
            alert('ระบบกำลังทำการส่ง email สำรหับแก้ไขรหัสผ่านไปที่')
            self.$router.push('/login')
          } else {
            // var message = response.result {"code":200,"status":"Validate Fails.","result":["The email has already been taken.","The citizen id has already been taken."]}
            var message = response.result.join()
            alert(message)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  main.register {
    padding: $header-height 0 30px;
    margin-top: 10px;
    .upload-image-wrapper {
      @extend .d-flex;
      margin-bottom: 10px;
      .upload-image {
        @extend .cursor-pointer;
        margin: auto;
        background-image: url('../assets/img/profile/upload-image-circle.png');
        height: 83px;
        width: 83px;
        display: flex;
        position: relative;
        .camera {
          margin: auto;
        }
      }
    }
    .gender-field {
      @extend .d-flex;
      margin-bottom: 10px;
      .gender-label {
        margin-bottom: 0;
        margin-right: 30px;
        line-height: 40px;
      }
    }
    hr {
      margin: 40px 0 20px;
    }

    .spacing-text{
      letter-spacing: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Reset.page.vue